<!-- =========================================================================================
    File Name: VxCard.vue
    Description: Card Component
    Component Name: VxCard

    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

 <template>
    <div class="vx-card" ref="card" :class="[
        {'overflow-hidden': tempHidden},
        {'no-shadow': noShadow},
        {'rounded-none': noRadius},
        {'card-border': cardBorder},
        ,
        cardClasses ]" :style="cardStyles"
        v-on="$listeners"
        @contextmenu.prevent="openContextMenu"
    >
        <div class="vx-card__header" v-if="hasHeader">

            <!-- card title -->
            <div class="vx-card__title" :class="{'opacity-50': done}" >
                <slot name="title"  >

                  <div class="flex items-center">
                    <feather-icon v-if="done" icon="CheckSquareIcon" :class="actionElementCss" class="ml-2 w-5 cursor-pointer font-semibold" @click.stop="$emit('toggleDone', !done)" />
                    <feather-icon v-else icon="SquareIcon" :class="actionElementCss" class="ml-2 w-5 cursor-pointer font-semibold" @click.stop="$emit('toggleDone', !done)" />

                    <AnchoredTitle class="ml-2 font-semibold" :title="title" :titleStyles="titleStyles" :titleClasses="titleClasses">
                      <!-- <span class="font-smaller" v-if="doneOn">({{doneOn.toDate() | dateWord}})</span> -->
                    </AnchoredTitle>

                  </div>

                    <!-- <feather-icon v-if="done" icon="DiscIcon" class="w-3 cursor-pointer text-danger" /> -->
                    <!-- <feather-icon v-else icon="DiscIcon" class="w-3 cursor-pointer  /> -->

                  <div class="text-sm ml-2">
                    <Deadline v-if="deadline" :value="deadline.toDate()" showOverdueDays="true"/>
                    <ExistsFor v-if="!task.deadline" :createdAt="task.createdAt.toDate()" :done="task.done" />

                    <div class="flex" v-if="task.relatedAreas">
                      <LifeArea v-for="lifeArea in task.relatedAreas" :lifeArea="lifeArea" class="mr-1" :showIcon="true" :hideText="true" size="small"/>
                    </div>
                  </div>
     <!--              <vs-progress
                    v-if="showProgress"
                    :percent="progressPercent"
                    color="primary"
                    style="opacity: 0.5;"
                    :height="4"
                  /> -->
                </slot>
            </div>

            <span :class="actionElementCss" @click.stop="$emit('openTask')" class="flex item mr-1">
              <p class="text-sm pr-1" v-if="subtaskIndicator" >{{subtaskIndicator}}</p>
              <feather-icon  icon="AlignLeftIcon" svgClasses="h-5 w-5" />
            </span>


            <!-- card actions -->
            <div v-if="hasAction">
                <slot name="actions">
                    <div class="vx-card__action-buttons" v-if="(actionButtons || collapseAction || refreshContentAction || removeCardAction) && !codeToggler">

                 <!-- <feather-icon @click.stop="toggleContent" icon="ChevronUpIcon" :class="{rotate180: isContentCollapsed}" class="p-1" v-if="actionButtons || collapseAction" /> -->

                  <div @click.stop="" class="py-1 items-center flex">
                    <!-- <vs-dropdown vs-trigger-click class="cursor-pointer hover:text-warning" > -->

                      <!-- <div class="py-1 cursor-pointer flex items-center justify-center text-lg font-medium w-32 w-full" > -->
                      <feather-icon icon="MoreVerticalIcon" svgClasses="h-5 w-5" @click="openContextMenu" :class="actionElementCss"/>
                      <!-- </div> -->


                      <context-menu id="tasks-context-menu" ref="ctxMenu">

                        <ContextMenuItem title="today" icon="CalendarIcon" @contextMenuClicked="$emit('today')" :disabled="taskBoxName == 'today'"/>

                        <ContextMenuItem title="tomorrow" icon="CalendarIcon" @contextMenuClicked="$emit('tomorrow')" :disabled="taskBoxName == 'tomorrow'"/>

                        <!-- <ContextMenuItem v-if="isStartOfTheWeek" title="next monday" icon="CalendarIcon" @contextMenuClicked="$emit('nextMonday')" /> -->


                        <ContextMenuNextDays @setDeadline="(deadline) => $emit('setDeadline', deadline)" :currentDeadline="deadline" />

                        <ContextMenuItem title="soon" icon="CalendarIcon" @contextMenuClicked="$emit('soon')" :disabled="taskBoxName == 'soon'"/>

                        <ContextMenuItem title="someday" icon="CornerDownRightIcon" @contextMenuClicked="$emit('someday')" :disabled="taskBoxName == 'someday'"/>

                         <!-- <vs-divider class="my-1"/>

                         <li>
                           <div class="flex justify-around">
                              <div class="mx-2">
                                <feather-icon icon="ChevronsUpIcon" :class="actionElementCss" class="ml-2 w-5 cursor-pointer font-semibold" @click.stop="$emit('toggleDone', !done)" />
                              </div>
                              <div class="mx-2">
                                <feather-icon icon="ChevronUpIcon" :class="actionElementCss" class="ml-2 w-5 cursor-pointer font-semibold" @click.stop="$emit('toggleDone', !done)" />
                              </div>
                              <div class="mx-2">
                                <feather-icon icon="ChevronDownIcon" :class="actionElementCss" class="ml-2 w-5 cursor-pointer font-semibold" @click.stop="$emit('toggleDone', !done)" />
                              </div>
                              <div class="mx-2">
                                <feather-icon icon="ChevronsDownIcon" :class="actionElementCss" class="ml-2 w-5 cursor-pointer font-semibold" @click.stop="$emit('toggleDone', !done)" />
                              </div>
                           </div>
                         </li> -->

                          <vs-divider class="my-1"/>

                        <ContextMenuColor :value="cardBackground" @colorChanged="(color) => $emit('colorChanged', color)" :namespace="`${task.id}-task`" />

                        <vs-divider class="my-1"/>

                        <ContextMenuItem title="edit" icon="EditIcon" @contextMenuClicked="$emit('edit')"/>

                       <ContextMenuItem title="delete" icon="Trash2Icon" @contextMenuClicked="$emit('destroy')" color="text-danger"/>


                        <!-- <li><div style="background-color: red">...<div></div></div> </li> -->
                      </context-menu>

                      <!-- <vs-dropdown-menu class="task__menu">
                          <vs-dropdown-item :disabled="taskBoxName == 'today'" @click.stop="$emit('today')">
                            <span class="flex items-center hover:font-semibold">
                              <feather-icon icon="CalendarIcon" svgClasses="h-4 w-4" class="mr-2" />
                              <span>today</span>
                            </span>
                          </vs-dropdown-item>

                          <vs-dropdown-item :disabled="taskBoxName == 'tomorrow'" @click.stop="$emit('tomorrow')">
                            <span class="flex items-center hover:font-semibold">
                              <feather-icon icon="CalendarIcon" svgClasses="h-4 w-4" class="mr-2" />
                              <span>tomorrow</span>
                            </span>
                          </vs-dropdown-item>

                          <vs-dropdown-item :disabled="taskBoxName == 'dayAfterTomorrow'" @click.stop="$emit('dayAfterTomorrow')">
                            <span class="flex items-center hover:font-semibold">
                              <feather-icon icon="CalendarIcon" svgClasses="h-4 w-4" class="mr-2" />
                              <span>{{$store.getters.dayAfterTomorrowWeekDay}}</span>
                            </span>
                          </vs-dropdown-item>


                          <vs-dropdown-item :disabled="taskBoxName == 'soon'" @click.stop="$emit('soon')">
                            <span class="flex items-center hover:font-semibold">
                              <feather-icon icon="CalendarIcon" svgClasses="h-4 w-4" class="mr-2" />
                              <span>soon</span>
                            </span>
                          </vs-dropdown-item>

                          <vs-dropdown-item :disabled="taskBoxName == 'someday'" @click.stop="$emit('someday')">
                            <span class="flex items-center hover:font-semibold">
                              <feather-icon icon="CornerDownRightIcon" svgClasses="h-4 w-4" class="mr-2" />
                              <span>backlog</span>
                            </span>
                          </vs-dropdown-item>
                        <vs-divider class="m-0" />

                        <vs-dropdown-item @click.stop="$emit('edit')">
                          <span class="flex items-center hover:font-semibold">
                            <feather-icon icon="EditIcon" svgClasses="h-4 w-4" class="mr-2" />
                            <span>edit</span>
                          </span>
                        </vs-dropdown-item>


                        <vs-dropdown-item @click.stop="$emit('destroy')">
                          <span class="flex items-center hover:font-semibold text-danger">
                            <feather-icon icon="Trash2Icon" svgClasses="h-4 w-4" class="mr-2" />
                            <span>delete</span>
                          </span>
                        </vs-dropdown-item>
 -->
                      <!-- </vs-dropdown-menu> -->
                    <!-- </vs-dropdown> -->

                    <feather-icon :class="actionElementCss" icon="ChevronRightIcon" svgClasses="h-5 w-5" @click.stop="$emit('edit')" />
                    </div>
                    </div>
                </slot>
            </div>
        </div>

        <div class="vx-card__collapsible-content vs-con-loading__container" ref="content" :class="[{collapsed: isContentCollapsed}, {'overflow-hidden': tempHidden}]" :style="StyleItems">

            <!-- content with no body(no padding) -->
            <slot name="no-body"></slot>

            <!-- content inside body(with padding) -->
            <div class="vx-card__body py-2" v-if="this.$slots.default">
                <slot></slot>
            </div>

            <!-- content with no body(no padding) -->
            <slot name="no-body-bottom"></slot>

            <div class="vx-card__footer" v-if="this.$slots.footer">
                <slot name="footer"></slot>
            </div>
        </div>

        <div class="vx-card__code-container" ref="codeContainer" v-show="this.$slots.codeContainer" :style="codeContainerStyles" :class="{collapsed: !showCode}">
            <div class="code-content">
                <prism :language="codeLanguage" :key="$vs.rtl">
                        <slot name="codeContainer"></slot>
                </prism>
            </div>
        </div>
    </div>
</template>

<script>
import Prism from 'vue-prism-component'
import _color from '@/assets/utils/color.js'
import DoubleClick from '../Generic/DoubleClick'
import { firstThreeDayOfWeek } from '@/helpers/date'
import LifeArea from './../Stories/LifeArea'

const MAX_HEIGHT = '0rem'

export default{
  name: 'vx-card',
  props: {
    title: String,
    subtitle: String,
    showProgress: Boolean,
    done: Boolean,
    progressPercent: Number,
    deadline: Object,
    doneOn: Object,
    task: Object,
    subtaskIndicator: String,
    taskHref: String,
    actionButtons: {
      type: Boolean,
      default: false
    },
    actionButtonsColor: {
      type: String,
      default: 'success'
    },
    codeToggler: {
      type: Boolean,
      default: false
    },
    noShadow: {
      default: false,
      type: Boolean
    },
    noRadius: {
      default: false,
      type: Boolean
    },
    cardBorder: {
      default: false,
      type: Boolean
    },
    codeLanguage: {
      default: 'markup',
      type: String
    },
    collapseAction: {
      default: true,
      type: Boolean
    },
    refreshContentAction: {
      default: false,
      type: Boolean
    },
    removeCardAction: {
      default: false,
      type: Boolean
    },
    headerBackground: {
      default: '',
      type: String
    },
    // bodyBackground: {
    //   default: '',
    //   type: String
    // },
    // headerbackground: {
    //   default: '',
    //   type: String
    // },
    cardBackground: {
      default: '',
      type: String
    },
    contentColor: {
      default: '',
      type: String
    },
    titleColor: {
      default: '',
      type: String
    },
    subtitleColor: {
      default: '#b8c2cc',
      type: String
    },
    taskBoxName: {
      default: '',
      type: String
    },
    collapsed: {
      default: false,
      type: Boolean
    },
  },
  data () {
    return {
      isContentCollapsed: false,
      showCode: false,
      codeContainerMaxHeight: '0px',
      maxHeight: null, // TODO: edit 1.5rem
      cardMaxHeight: null,
      tempHidden: false,
      animationLock: false,
    }
  },
  created () {
    this.$root.$on('closeAllContextMenus', () => {
      if (this.$refs.ctxMenu) {
        this.$refs.ctxMenu.ctxVisible = false
      }
    })
  },
  mounted () {
    this.tempHidden = this.collapsed
    this.isContentCollapsed = this.collapsed
    this.maxHeight = this.collapsed ? MAX_HEIGHT : null
  },
  watch: {
    collapsed: {
      immediate: false,
      handler (collapsed) {
        this.tempHidden = collapsed
        this.isContentCollapsed = collapsed
        this.maxHeight = collapsed ? MAX_HEIGHT : null
      }
    }
  },
  computed: {
    backgroundColor () {
      switch (this.cardBackground) {
      case '#000000': return 'linear-gradient(to bottom right, #000000, #4C4C4C)'
      case '#3D3270': return 'linear-gradient(to bottom right, #3D3270, #776F9A)'
      case '#424CE2': return 'linear-gradient(to bottom right, #424CE2, #7A81EA)'
      case '#FC9905': return 'linear-gradient(to bottom right, #FC9905, #FCB750)'
      case '#2196F3': return 'linear-gradient(to bottom right, #2196F3, #63B5F6)'
      case '#9C28B1': return 'linear-gradient(to bottom right, #9C28B1, #B968C8)'
      case '#E91D62': return 'linear-gradient(to bottom right, #E91D62, #EF6091)'
      case '#F34336': return 'linear-gradient(to bottom right, #F34336, #F67B72)'
      case '#FFB800': return 'linear-gradient(to bottom right, #FFB800, #FFCD4C)'
      case '#21C228': return 'linear-gradient(to bottom right, #21C229, #63D469)'
      default: return this.cardBackground
      }
    },
    isStartOfTheWeek () {
      return firstThreeDayOfWeek()
    },
    hasAction () {
      return this.$slots.actions || (this.actionButtons || this.collapseAction || this.refreshContentAction || this.removeCardAction || this.codeToggler)
    },
    hasHeader () {
      return this.hasAction || (this.title || this.subtitle) || (!!this.$slots['title'] || !!this.$scopedSlots['title'])
    },
    StyleItems () {
      return { maxHeight: this.maxHeight }
    },
    cardStyles () {
      const obj = { maxHeight: this.cardMaxHeight }
      if (!_color.isColor(this.backgroundColor)) obj.background = _color.getColor(this.backgroundColor)
      if (!_color.isColor(this.contentColor)) obj.color = _color.getColor(this.contentColor)
      return obj
    },
    codeContainerStyles () {
      return { maxHeight: this.codeContainerMaxHeight }
    },
    cardClasses () {
      let str = ''

      // Add bg class
      if (_color.isColor(this.backgroundColor)) {
        str += ` bg-${this.backgroundColor}`
      }

      // add content color
      if (_color.isColor(this.contentColor)) {
        str += ` text-${this.contentColor}`
      }

      return str.trim()
    },
    titleStyles () {
      return {
        color: _color.getColor(this.titleColor)
      }
    },
    titleClasses () {
      let str = ''

      // add content color
      if (_color.isColor(this.titleColor)) {
        str += ` text-${this.titleColor}`
      }

      if (this.done) str += ' line-through  '

      return str.trim()
    },
    subtitleStyles () {
      const obj = {}
      if (!_color.isColor(this.subtitleColor)) obj.color = _color.getColor(this.subtitleColor)

      return obj
    },
    subtitleClasses () {
      let str = ''

      // add content color
      if (_color.isColor(this.subtitleColor)) {
        str += ` text-${this.subtitleColor}`
      }

      return str.trim()
    }
  },
  methods: {
    openContextMenu () {
      this.$root.$emit('closeAllContextMenus')

      if (this.$refs.ctxMenu) {
        this.$refs.ctxMenu.open()
      }
    },
    toggleContent () {
      if (this.animationLock) return
      this.$refs.content.style.overflow = 'hidden'
      const scrollHeight = this.$refs.content.scrollHeight
      if (this.isContentCollapsed) {
        this.animationLock = true
        this.maxHeight = `${scrollHeight}px`
        // setTimeout(() => {
        this.maxHeight = 'none'
        this.animationLock = false
        this.$refs.content.style.overflow = null
        // }, 50)
      } else {
        this.animationLock = true
        this.maxHeight = `${scrollHeight}px`
        // setTimeout(() => {
        this.maxHeight = MAX_HEIGHT
        this.animationLock = false
        this.$refs.content.style.overflow = null
        // }, 50)
      }
      this.isContentCollapsed = !this.isContentCollapsed
      this.$emit('toggleCollapse', this.isContentCollapsed)
    },
    refreshcard () {
      this.$vs.loading({
        container: this.$refs.content,
        scale: 0.5
      })
      this.tempHidden = true
      this.$emit('refresh', this)
    },
    removeRefreshAnimation (time = 100) {
      setTimeout(() => {
        this.$vs.loading.close(this.$refs.content)
        this.tempHidden = false
      }, time)
    },
    removeCard () {
      const scrollHeight = this.$refs.card.scrollHeight
      this.cardMaxHeight = `${scrollHeight}px`
      this.$el.style.overflow = 'hidden'
      setTimeout(() => {
        this.cardMaxHeight = '0px'
      }, 50)
      this.$emit('remove')
    },
    toggleCode () {
      this.tempHidden = true
      this.showCode = !this.showCode
      const scrollHeight = this.$refs.codeContainer.scrollHeight
      if (this.codeContainerMaxHeight === '0px') {
        this.codeContainerMaxHeight = `${scrollHeight}px`
        setTimeout(() => {
          this.codeContainerMaxHeight = 'none'
          this.tempHidden = false
        }, 300)
      } else {
        this.codeContainerMaxHeight = `${scrollHeight}px`
        setTimeout(() => {
          this.codeContainerMaxHeight = '0px'
          this.tempHidden = false
        }, 150)
      }
    }
  },
  components: {
    Prism,
    DoubleClick,
    LifeArea
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/components/vxCard.scss"

</style>
<style lang="scss">
.task {
  &__menu {
    min-width: 320px;
  }
}
</style>
